import React, {ReactElement, useMemo} from "react";
import {useAccount} from "../../../administration/users/AccountProvider";
import {TabsProvider} from "./TabsProvider";
import {ContentTabs} from "./ContentTabs";
import {ContentTab} from "./ContentTab";
import {isVisible, WithRestrictedVisibility} from "../../technical/security/WithRestrictedVisibility";
import {User} from "../../../administration/users/User";

export type TabDefinition = {
  titleKey: string,
  component: ReactElement,
} & WithRestrictedVisibility

function tabVisibleForUser(account: User) {
  return (tabDef: TabDefinition) => isVisible(account, tabDef);
}

export function TabsContentPage(props: {
  tabs: TabDefinition[]
}) {
  const account = useAccount();
  const visibleTabs = useMemo(() => props.tabs.filter(tabVisibleForUser(account)), [account, props.tabs]);

  const tabTitles = visibleTabs.map((tabDef) => tabDef.titleKey);

  if(visibleTabs.length === 0) {
    return (
      <div>Sorry, there are no tabs visible for the current user</div>
    )
  }

  return (
    <TabsProvider>
      <ContentTabs tabTitleKeys={tabTitles}/>
      {visibleTabs.map((tabDef, index) => <ContentTab tabIndex={index} component={tabDef.component} key={index}/>)}
    </TabsProvider>
  )
}
